/** CRM-only headers for /connect/token (SSO + refresh). Teams clients are unchanged. */
export function getConnectTokenHeaders(accountId: string): Headers {
  return new Headers({
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    'x-account-id': accountId || '',
  })
}
